"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const Recommendations_1 = require("@becrop/abstract/Models/Recommendations");
const Controller_1 = __importDefault(require("@becrop/components/Map/Controller"));
const MapZone_1 = __importDefault(require("@becrop/components/Map/models/MapZone"));
const ExporterSetupRaster_1 = require("@becrop/components/Map/ModelsT/ExporterSetupRaster");
const Utils_1 = require("@becrop/components/Map/Utils");
const GeometryCollection_1 = __importDefault(require("ol/geom/GeometryCollection"));
const proj_1 = require("ol/proj");
const CenterUtility_1 = require("@becrop/components/Map/models/CenterUtility");
const style_1 = require("ol/style");
const MapTooltip_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapTooltip.vue"));
const MapTooltipRecommendationSection_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapTooltipRecommendationSection.vue"));
const MapTooltipMetricSection_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapTooltipMetricSection.vue"));
const MapTooltipNeedMapSection_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/MapTooltipNeedMapSection.vue"));
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
const GeoTIFF_1 = __importDefault(require("ol/source/GeoTIFF"));
const WebGLTile_js_1 = __importDefault(require("ol/layer/WebGLTile.js"));
const Utils_2 = require("@becrop/components/Map/Utils");
const ColorLibController_1 = __importDefault(require("../../Abstract/Controllers/ColorLibController"));
const FieldMapTooltip_vue_1 = __importDefault(require("@becrop/components/Common/FieldMapTooltip.vue"));
const DynamicLegend_vue_1 = __importDefault(require("@becrop/components/Common/DynamicLegend.vue"));
let BeCropMap = class BeCropMap extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.MAP_CONTROLLER = new Controller_1.default();
        this.MAP_ID = `map-${this.id}`;
        this.TOOLTIP_FIELD_ID = `tooltip-field-${this.id}`;
        this.isLoadingReport = false;
        this.maxValuePHCH = '';
        this.minValuePHCH = '';
        this.colorController = new ColorLibController_1.default();
        this.eventTracker = new EventTracker_1.default();
        this.fieldActive = new Recommendations_1.FieldRecommendation({}, []);
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get hasDynamicLegend() {
        const stats = ('stats' in this.panel.metric) ? this.panel.metric.stats : null;
        if (stats.pixels_data) {
            const percentages = stats.pixels_data.pixels_percentage;
            const totalPercentages = percentages.rank_1 + percentages.rank_2 + percentages.rank_3 + percentages.rank_4 + percentages.rank_5;
            const extensions = stats.pixels_data.pixels_extension;
            const totalExtensions = extensions.rank_1 + extensions.rank_2 + extensions.rank_3 + extensions.rank_4 + extensions.rank_5;
            if (totalPercentages > 0 || totalExtensions > 0)
                return true;
            else
                return false;
        }
        else
            return false;
    }
    get valuesPercentage() {
        const stats = ('stats' in this.panel.metric) ? this.panel.metric.stats : null;
        const percentages = stats.pixels_data.pixels_percentage;
        return {
            vhigh: `${percentages.rank_5.toFixed(0)}`,
            high: `${percentages.rank_4.toFixed(0)}`,
            medium: `${percentages.rank_3.toFixed(0)}`,
            low: `${percentages.rank_2.toFixed(0)}`,
            vlow: `${percentages.rank_1.toFixed(0)}`,
        };
    }
    get valuesAcreage() {
        const stats = ('stats' in this.panel.metric) ? this.panel.metric.stats : null;
        const extensions = stats.pixels_data.pixels_extension;
        return {
            vhigh: `${extensions.rank_5.toFixed(0)}`,
            high: `${extensions.rank_4.toFixed(0)}`,
            medium: `${extensions.rank_3.toFixed(0)}`,
            low: `${extensions.rank_2.toFixed(0)}`,
            vlow: `${extensions.rank_1.toFixed(0)}`,
        };
    }
    get barChartConfig() {
        if (this.fieldActive.areaID === -1)
            return null;
        const currentFieldMetric = this.fieldActive.metrics.find((metric) => metric.name === this.metricInActiveField.name);
        // Verificamos que currentFieldMetric exista y que tenga la propiedad 'stats'
        if (!currentFieldMetric || !currentFieldMetric.stats || !currentFieldMetric.stats.pixels_data) {
            return null;
        }
        const scale = 'scale' in this.panel.metric ? this.panel.metric.scale : 'std';
        const formatValue = (value) => (value === 0 ? value : value.toFixed(1));
        const getConfig = (getColorMethod) => {
            return [1, 2, 3, 4, 5].map((rank) => ({
                rank: this.colorController[getColorMethod](rank.toString()),
                acreage: formatValue(currentFieldMetric.stats.pixels_data.pixels_extension[`rank_${rank}`]),
                percentage: formatValue(currentFieldMetric.stats.pixels_data.pixels_percentage[`rank_${rank}`])
            }));
        };
        return scale === 'hlt' ? getConfig('getDiseasesColor') : getConfig('getRankColor');
    }
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
    get config() {
        var _a, _b, _c, _d;
        return {
            tiffUrl: '',
            isNeedMaps: false,
            needMap: null,
            isComparison: false,
            isMainPanel: true,
            dimension: (_b = (_a = this.panel) === null || _a === void 0 ? void 0 : _a.metric) === null || _b === void 0 ? void 0 : _b.dimension,
            bioMetric: (_c = this.panel) === null || _c === void 0 ? void 0 : _c.metric,
            phchMetric: (_d = this.panel) === null || _d === void 0 ? void 0 : _d.metric,
            vsMetric: null,
            vsPhChMetric: null
        };
    }
    get metricInActiveField() {
        return this.fieldActive.metrics.find((fm) => fm.code_name === this.panel.metric.code_name);
    }
    get agInsightInSelectedFieldForSelectedMetric() {
        if ('category' in this.panel.metric) {
            return this.panel.farm.hasFieldAgInsightForMetric(this.fieldActive, this.panel.metric);
        }
    }
    get currentFieldName() {
        var _a, _b;
        return ((_b = (_a = this.MAP_CONTROLLER) === null || _a === void 0 ? void 0 : _a.currentzoneSelected) === null || _b === void 0 ? void 0 : _b.get('name')) || '';
    }
    async openFpdfReport(field) {
        var _a, _b;
        this.isLoadingReport = true;
        const fieldMapName = ((_a = this.MAP_CONTROLLER.currentzoneSelected) === null || _a === void 0 ? void 0 : _a.get('name')) ? (_b = this.MAP_CONTROLLER.currentzoneSelected) === null || _b === void 0 ? void 0 : _b.get('name') : '';
        try {
            const currentGisField = this.panel.farm.gisFields.find((gisField) => {
                return gisField.name === field.name;
            });
            const needsAccurateReport = currentGisField !== undefined &&
                currentGisField.id !== -1 &&
                currentGisField.results_stats.metrics !== undefined &&
                currentGisField.results_stats.metrics.length > 0;
            const gisFieldId = currentGisField !== undefined && currentGisField.id !== -1 ? currentGisField.id : -1;
            if (gisFieldId > 0) {
                await field.downloadFieldReportPDF(this.panel.farm.meta.project_id.toString(), this.panel.farm.meta.area_id.toString(), needsAccurateReport, gisFieldId, fieldMapName);
            }
            else {
                throw new Error(`Error fetching or opening PDF, Field ID not valid: ${gisFieldId}`);
            }
        }
        catch (error) {
            console.error('Error fetching or opening PDF:', error);
        }
        this.isLoadingReport = false;
    }
    zoomIn() {
        this.MAP_CONTROLLER.zoomIn();
        this.eventTrackerListener('mapZoomInComparativeMode', { currentZoom: this.MAP_CONTROLLER.map.getView().get('zoom') });
    }
    zoomOut() {
        this.MAP_CONTROLLER.zoomOut();
        this.eventTrackerListener('mapZoomOutComparativeMode', { currentZoom: this.MAP_CONTROLLER.map.getView().get('zoom') });
    }
    async drawRaster() {
        if (this.panel.metric) {
            (0, Utils_1.removeLayersById)('raster-layer', this.MAP_CONTROLLER.map);
            const hasHLT = this.panel.metric.code_name === 'HLT' && this.panel.metric.type_code === 'GS';
            const name = `raster-layer-${this.panel.metric.code_name}-${this.panel.farm.meta.area_id}`;
            const scale = ('scale' in this.panel.metric) ? this.panel.metric.scale : 'std';
            const color = hasHLT ? (0, ExporterSetupRaster_1.getResultConfigRasterTo5Scale)(scale) : (0, ExporterSetupRaster_1.getResultConfigRaster)(scale);
            const maxRange = hasHLT ? 5 : 100;
            let max = '';
            let min = '';
            if (this.panel.metric.dimension === 'phch') {
                const source = new GeoTIFF_1.default({
                    sources: [{ url: this.panel.metric.rasterUrl }],
                    interpolate: false,
                });
                const layer = new WebGLTile_js_1.default({ source: source, visible: true, cacheSize: 150, preload: 3 });
                (0, Utils_2.addLayerToMap)(layer, 'raster-layer-phch', 5, this.MAP_CONTROLLER.map);
                await new Promise((resolve) => {
                    source.on('change', () => {
                        if (source.getState() === 'ready') {
                            max = `${source.metadata_[0][0].STATISTICS_MAXIMUM}`;
                            min = `${source.metadata_[0][0].STATISTICS_MINIMUM}`;
                            /*                             console.log("\x1b[35m%s\x1b[0m",'***RASTER PHCH METADATA***')
                                                        console.log(source.metadata_[0][0]) */
                            resolve();
                        }
                    });
                });
                this.maxValuePHCH = parseFloat(max).toFixed(2);
                this.minValuePHCH = parseFloat(min).toFixed(2);
            }
            else {
                this.MAP_CONTROLLER.rasterBuilder.drawRaster({ url: this.panel.metric.rasterUrl, nodata: 255, max: maxRange, min: 0 }, { color: color, name: name, zindex: 5 });
            }
        }
    }
    drawField(field) {
        if (this.panel.metric) {
            this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
                geoData: field.polygon,
                fillColor: field.fillColor(this.config),
                strokeColor: field.strokeColor(this.config),
                centerZone: false,
                enableHoverInteraction: true,
                enableSelectInteraction: true,
                zoneName: `${field.name}${field.id}`,
                avg: 0,
                markers: [],
                preciseResult: false
            }), 700, [100, 100, 100, 100]);
        }
        else {
            this.MAP_CONTROLLER.zoneBuilder.drawZone(new MapZone_1.default({
                geoData: field.polygon,
                fillColor: '#32323210',
                strokeColor: '#323232',
                centerZone: false,
                enableHoverInteraction: true,
                enableSelectInteraction: true,
                zoneName: `${field.name}${field.id}`,
                avg: 0,
                markers: [],
                preciseResult: false
            }), 700, [100, 100, 100, 100]);
        }
    }
    updateMetricInMap() {
        var _a;
        if (this.panel.metric) {
            const fieldsFeatures = (_a = (0, Utils_1.findLayerById)('zone-layer', this.MAP_CONTROLLER.map)) === null || _a === void 0 ? void 0 : _a.getSource().getFeatures();
            if (fieldsFeatures) {
                fieldsFeatures.forEach((fieldFeat) => {
                    var _a;
                    const fieldName = fieldFeat.get('name');
                    const field = this.panel.farm.fields.find((f) => `${f.name}${f.id}` === fieldName);
                    if (field) {
                        const fill = new style_1.Fill({ color: field.fillColor(this.config) });
                        const stroke = new style_1.Stroke({
                            color: this.MAP_CONTROLLER.zoneSelected && (((_a = this.MAP_CONTROLLER.zoneSelected) === null || _a === void 0 ? void 0 : _a.get('name')) === `${field.name}${field.id}`) ?
                                '#FFF' :
                                field.strokeColor(this.config), width: 3
                        });
                        const newStyle = new style_1.Style({ fill: fill, stroke: stroke });
                        fieldFeat.setStyle(newStyle);
                        fieldFeat.set('style', newStyle);
                    }
                });
            }
            this.drawRaster();
        }
    }
    get overlayBuilder() {
        return this.MAP_CONTROLLER.overlayBuilder;
    }
    updateFarmInMap() {
        (0, Utils_1.removeLayersById)('zone-layer', this.MAP_CONTROLLER.map);
        (0, Utils_1.removeLayersById)('raster-layer', this.MAP_CONTROLLER.map);
        this.overlayBuilder.visibilityOverlay(this.TOOLTIP_FIELD_ID, false);
        const geodatas = [];
        this.panel.farm.fields.forEach((f) => {
            this.drawField(f);
            geodatas.push(f.polygon);
        });
        const polygonsWkt = geodatas.map(Utils_1.parseWKT);
        const combinedGeometry = new GeometryCollection_1.default(polygonsWkt);
        const extent = (0, proj_1.transformExtent)(combinedGeometry.getExtent(), 'EPSG:4326', 'EPSG:3857');
        (0, CenterUtility_1.center)(this.MAP_CONTROLLER.map, extent, 700, [100, 100, 100, 100]);
        this.drawRaster();
    }
    setFieldAsActiveFromMap() {
        var _a;
        // Check if there's a selected zone
        //  - YES: Check if selected zone is the same as already active
        //              - YES: Do nothing
        //              - NO: Assign Active and emit
        //  - NO: Assign Active and emit
        if (this.MAP_CONTROLLER.zoneSelected) {
            if (((_a = this.MAP_CONTROLLER.zoneSelected) === null || _a === void 0 ? void 0 : _a.get('name')) !== this.fieldActive.name) {
                this.fieldActive = this.panel.farm.fields.find((f) => { var _a; return `${f.name}${f.id}` === ((_a = this.MAP_CONTROLLER.zoneSelected) === null || _a === void 0 ? void 0 : _a.get('name')); });
            }
        }
        else {
            this.MAP_CONTROLLER.zoneSelected = null;
            this.fieldActive = new Recommendations_1.FieldRecommendation({}, []);
        }
    }
    mounted() {
        this.MAP_CONTROLLER.create(this.MAP_ID, this.map_config.provider, this.map_config.apikey, this.TOOLTIP_FIELD_ID, '', '');
        this.updateFarmInMap();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], BeCropMap.prototype, "panel", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], BeCropMap.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], BeCropMap.prototype, "id", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], BeCropMap.prototype, "defaultHeader", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], BeCropMap.prototype, "defaultFooter", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], BeCropMap.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], BeCropMap.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], BeCropMap.prototype, "data", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('panel.metric')
], BeCropMap.prototype, "updateMetricInMap", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('panel.farm')
], BeCropMap.prototype, "updateFarmInMap", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('MAP_CONTROLLER.zoneSelected')
], BeCropMap.prototype, "setFieldAsActiveFromMap", null);
BeCropMap = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            MapTooltip: MapTooltip_vue_1.default,
            MapTooltipRecommendationSection: MapTooltipRecommendationSection_vue_1.default,
            MapTooltipMetricSection: MapTooltipMetricSection_vue_1.default,
            MapTooltipNeedMapSection: MapTooltipNeedMapSection_vue_1.default,
            MapAttributions: bmk_ui_framework_1.MapAttributions,
            ScaleLegend: bmk_ui_framework_1.ScaleLegend,
            FieldMapTooltip: FieldMapTooltip_vue_1.default,
            Button: bmk_ui_framework_1.Button,
            Plus: lucide_vue_next_1.Plus,
            Minus: lucide_vue_next_1.Minus,
            DynamicLegend: DynamicLegend_vue_1.default
        },
    })
], BeCropMap);
exports.default = BeCropMap;
